import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7545bacc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545bacc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTop: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/header/HeaderTop.vue').default,Menu: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/Menu.vue').default,Header: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/header/Header.vue').default,Banner: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/Banner.vue').default})
